/* eslint-disable react/jsx-key -- TODO: remove this eslint-disable and fix the error */
import { getBulkContactExportStatus } from './BulkContactExportMonitoring.api'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from '../../../../Permissions'
import { LinearProgress } from 'beam/dist/Progress'
import moment from 'moment-timezone'
import { Button } from 'beam/dist/Button'
import { Route } from 'react-router-dom'
import Form from '../../Common/Form'

import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'beam/dist/Table'
import { Formik } from 'formik'

const createCancelSubmissionHandler = history => () => history.push('/admin')

/** @deprecated Replace entirely with flo variant when grid BCEM has been removed */
export const BulkContactExportMonitoring = () => {
  const user = useUser()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const [bulkContactExports, setBulkContactExports] = useState([])

  useEffect(() => {
    getBceData()
  }, [])

  const getBceData = () => {
    setIsLoading(true)
    getBulkContactExportStatus()
      .then(resp => {
        setIsLoading(false)
        setBulkContactExports(resp)
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  return (
    <Formik>
      <Form
        title={t('bulkExportAuditTitle')}
        description={t('bulkExportAuditDescription')}
        buttons={[
          <Button
            key={0}
            variant="outlined"
            color="primary"
            type="submit"
            onClick={getBceData}
            disabled={isLoading}
            data-testid="BulkContactExport-Save"
          >
            {t('refresh')}
          </Button>,
          <Route
            key={1}
            render={({ history }) => (
              <Button
                variant="text"
                color="default"
                onClick={createCancelSubmissionHandler(history)}
                data-testid="BulkContactExport-Cancel"
              >
                {t('cancel')}
              </Button>
            )}
          />,
        ]}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('date')}</TableCell>
              <TableCell>{t('name')}</TableCell>
              <TableCell>{t('bulkExportStatusName')}</TableCell>
              <TableCell>{t('taskCount')}</TableCell>
              <TableCell>{t('tasksQueued')}</TableCell>
              <TableCell>{t('tasksInProgress')}</TableCell>
              <TableCell>{t('tasksFinished')}</TableCell>
              <TableCell>{t('uploadsQueued')}</TableCell>
              <TableCell>{t('uploadsSucceeded')}</TableCell>
              <TableCell>{t('uploadsFailed')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading && <LinearProgress color="secondary" />}
            {!isLoading &&
            bulkContactExports.map(item => {
              return (
                <TableRow>
                  <TableCell> {moment.tz(item.date, user.timezoneString).format('MM/DD/YYYY HH:mm:ss')} </TableCell>
                  <TableCell> {item.name} </TableCell>
                  <TableCell> {item.batchRequest.currentState.name} </TableCell>
                  <TableCell> {item.batchRequest.taskCount} </TableCell>
                  <TableCell> {item.batchRequest.tasksQueued} </TableCell>
                  <TableCell> {item.batchRequest.tasksInProgress} </TableCell>
                  <TableCell> {item.batchRequest.tasksFinished} </TableCell>
                  <TableCell> {item.batchRequest.uploadsQueued} </TableCell>
                  <TableCell> {item.batchRequest.uploadsSucceeded} </TableCell>
                  <TableCell> {item.batchRequest.uploadsFailed} </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </Form>
    </Formik>
  )
}

/* eslint-enable react/jsx-key -- required re-enable directive */
